var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.732,
    height: 72.859,
    viewBox: "0 0 126.732 72.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav",
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-cined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M28,24.292V48.567l99.224,24.293V0Zm1.433,22.967H98.1V25.6H29.433Z",
    transform: "translate(-0.492)",
    fill: "#391d69",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M27.7,0,0,49.585H99.224V24.8Z",
    fill: "#f49800",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M30,47.251H98.769V26H30Z",
    transform: "translate(-0.527 0.31)",
    fill: "#391d69",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M68,41.107H78.782V39.748H69.453V37.117h8.586v-1.36H69.453V33.363h9.354V32H68Z",
    transform: "translate(-1.195 0.382)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(36.532 31.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M48.862,8.472c-2.321,0-4.207-.636-4.207-2.052s1.192-2.108,4.219-2.1,4.211.7,4.207,2.123-1.888,2.027-4.219,2.027Zm4.189-4.535a9.8,9.8,0,0,0-4.681-.97c-3.212-.011-5.285,1.063-5.285,3.342,0,2.433,2.419,3.461,5.258,3.461A8.977,8.977,0,0,0,53.074,8.8l.23.8h1.134V.506H53.051V3.937Z",
    transform: "translate(-0.94 -0.335)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M24.29,2.933a9.7,9.7,0,0,0-4.777,1.219L19.3,3.089H18.162V9.572h1.427V5.428a8.794,8.794,0,0,1,4.579-1.144C26.144,4.29,27.7,4.8,27.7,6.493V9.572h1.431V6.349c0-2.322-1.733-3.416-4.838-3.416",
    transform: "translate(-0.502 -0.306)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M14.7,9.57h1.434V3.087H14.7Z",
    transform: "translate(-0.441 -0.305)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M14.7,1.866h1.431V.507H14.7Z",
    transform: "translate(-0.441 -0.335)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M7.212,1.73a22.162,22.162,0,0,1,5.088.61V.937a18.986,18.986,0,0,0-5.331-.6C2.532.323.186,1.855.186,5.06S2.532,9.787,6.969,9.771a20.313,20.313,0,0,0,5.511-.6v-1.4a23.888,23.888,0,0,1-5.268.608c-3.523.013-5.481-.816-5.481-3.324S3.689,1.718,7.212,1.73",
    transform: "translate(-0.186 -0.337)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.28940891216dbe35f930e967883a9b62.svg";
export { ForwardRef as ReactComponent };